// Reusable SEO content + JSON-LD generators

export const SITE_URL = "https://www.cityworthloans.com";
export const COMPANY = {
  name: "CityWorth Mortgage",
  legalName: "CityWorth Mortgage",
  description:
    "CityWorth Mortgage delivers an all-in-one homebuying experience, mortgage and real estate under one roof. Simplifying the path from home searching to loan approval.",
  url: SITE_URL,
  logo: "https://customer-assets.emergentagent.com/job_happy-homes-ahead/artifacts/0buyd3la_CW%20Logo%20%281%29.svg",
  phone: "+1-571-555-1234",
  email: "info@cityworth.com",
  nmlsId: "925476",
  address: {
    street: "11781 Lee Jackson Hwy Ste 100",
    city: "Fairfax",
    state: "VA",
    postalCode: "22033",
    country: "US",
  },
  sameAs: [
    "https://www.linkedin.com/company/cityworth-mortgage",
    "https://www.facebook.com/cityworthmortgage",
  ],
};

// Organization JSON-LD (used site-wide)
export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "MortgageBroker",
  "@id": `${SITE_URL}/#organization`,
  name: COMPANY.name,
  legalName: COMPANY.legalName,
  url: COMPANY.url,
  logo: COMPANY.logo,
  image: COMPANY.logo,
  description: COMPANY.description,
  telephone: COMPANY.phone,
  email: COMPANY.email,
  identifier: `NMLS#${COMPANY.nmlsId}`,
  address: {
    "@type": "PostalAddress",
    streetAddress: COMPANY.address.street,
    addressLocality: COMPANY.address.city,
    addressRegion: COMPANY.address.state,
    postalCode: COMPANY.address.postalCode,
    addressCountry: COMPANY.address.country,
  },
  areaServed: { "@type": "Country", name: "United States" },
  sameAs: COMPANY.sameAs,
};

// Helper: build BreadcrumbList JSON-LD
export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

// Helper: build FAQPage JSON-LD
export const faqJsonLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

// Helper: WebPage JSON-LD
export const webPageJsonLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  name,
  description,
  url: `${SITE_URL}${path}`,
  isPartOf: { "@id": `${SITE_URL}/#website` },
  about: { "@id": `${SITE_URL}/#organization` },
});

// Helper: Service JSON-LD for loan programs
export const loanServiceJsonLd = (program) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: program.name,
  name: program.name,
  description: program.subhead,
  provider: { "@id": `${SITE_URL}/#organization` },
  areaServed: { "@type": "Country", name: "United States" },
  url: `${SITE_URL}/loans/${program.slug}`,
});

// Helper: merge multiple JSON-LD objects into a @graph (cleaner for crawlers)
export const buildGraph = (...nodes) => ({
  "@context": "https://schema.org",
  "@graph": nodes.filter(Boolean),
});

// WebSite node (enables sitelinks search box in Google)
export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: "CityWorth Mortgage",
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en-US",
};
